import { render, staticRenderFns } from "./zj-pie.vue?vue&type=template&id=3af6a2b2&"
import script from "./zj-pie.vue?vue&type=script&lang=js&"
export * from "./zj-pie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\桌面\\学习资料\\ZXX\\ZJPMWEB\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3af6a2b2')) {
      api.createRecord('3af6a2b2', component.options)
    } else {
      api.reload('3af6a2b2', component.options)
    }
    module.hot.accept("./zj-pie.vue?vue&type=template&id=3af6a2b2&", function () {
      api.rerender('3af6a2b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/common/zj-chart/zj-pie.vue"
export default component.exports